/** @jsx jsx */
import { jsx } from '@emotion/react';
import { Button, Classes, MenuItem } from '@blueprintjs/core';
import { Select } from '@blueprintjs/select';
import { useContext } from 'react';
import { WorkspaceContext } from 'views/workspace/workspaceContext';
import { WorkspaceActionCreator } from 'hooks/useWorkspaceState';
import { SlykitContext } from '/slykitContext';

export const LayoutSelector = ({ layoutOptions }) => {
	const {
		state: {
			explorer: {
				layout: { layoutStyle },
			},
		},
		dispatch,
	} = useContext(WorkspaceContext);
	const {
		state: { savedStates },
	} = useContext(SlykitContext);

	function onSelectionChanged(layout) {
		dispatch(
			WorkspaceActionCreator.updateExplorerLayout({ key: layout.key, cardCount: layout.cardCount }, savedStates)
		);
	}

	return (
		<Select
			items={Object.values(layoutOptions)}
			onItemSelect={onSelectionChanged}
			activeItem={layoutOptions[layoutStyle.key]}
			itemRenderer={ItemRenderer}
			filterable={false}
			popoverProps={{ minimal: true }}
		>
			<Button
				cy-test="panel-dropdown"
				icon={'page-layout'}
				rightIcon={'caret-down'}
				minimal
				fill
			// className={minimal ? `${Classes.MINIMAL}` : ''}
			>
				{layoutOptions[layoutStyle.key].label}
				{/* firefox bug? */}
			</Button>
		</Select>
	);
};

const ItemRenderer = (layout, { handleClick, modifiers, index }) => {
	if (!modifiers.matchesPredicate) {
		return null;
	}
	return (
		<MenuItem
			cy-test={layout.key}
			key={index}
			active={modifiers.active}
			disabled={modifiers.disabled}
			onClick={handleClick}
			text={layout.label}
		/>
	);
};
